import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n).use(require('vue-cookies'))

Vue.config.productionTip = false

// eslint-disable-next-line no-unused-vars
const messages = {
  en: {
    filter: 'Filter',
    delete: 'Clear',
    type: 'Job Type',
    category: 'Category',
    location: 'Location',
    find_your_job: 'Find your new job',
    job_search: 'Job search',
    types: {
        full_time: 'Full Time',
        part_time: 'Part Time',
        apprenticeship: 'Apprenticeship',
        internship: 'Internship',
    },
    locations: {
      lang: 'en',
        at: {
          title: 'Austria',
          ko: 'Kollerschlag',
          al: 'Alberndorf',
          wi: 'Wien',
        },
        de: {
          title: 'Germany',
          wa: 'Wäschenbeuren',
          ha: 'Hannover',
        },
        ch: {
          title: 'Switzerland',
          st: 'Steckborn',
          be: 'Bern',
        },
        it: {
          title: 'Italy',
          ne: 'Neumarkt',
          mi: 'Milan',
          su: 'Südtirol',
        },
        es: {
          title: 'Spain',
          ar: 'Artes',
          ma: 'Madrid',
        },
        fr: {
          title: 'France',
        },
        cz: {
          title: 'Czech Republic',
        },
        sk: {
          title: 'Slovakia',
        },
        pl: {
          title: 'Poland',
        },
        be: {
          title: 'Belgium',
        },
        nl: {
          title: 'Netherlands'
        },
        uk: {
          title: 'United Kingdom',
        },
        cn: {
          title: 'China',
        },
        us: {
          title: 'USA',
        },
        
    }

  },
  de: {
    filter: 'Filter',
    delete: 'Löschen',
    type: 'Anstellung',
    category: 'Kategorie',
    location: 'Standort',
    find_your_job: 'Finden Sie Ihren neuen Job',
    job_search: 'Jobs suchen',
    types: {
        full_time: 'Vollzeit',
        part_time: 'Teilzeit',
        apprenticeship: 'Lehre',
        internship: 'Praktikum',
    },
    locations: {
        lang: 'de',
        at: {
          title: 'Österreich',
          ko: 'Kollerschlag',
          al: 'Alberndorf',
          wi: 'Wien',
        },
        de: {
          title: 'Deutschland',
          wa: 'Wäschenbeuren',
          ha: 'Hannover',
        },
        ch: {
          title: 'Schweiz',
          st: 'Steckborn',
          be: 'Bern',
        },
        it: {
          title: 'Italien',
          ne: 'Neumarkt',
          mi: 'Milan',
          su: 'Südtirol',
        },
        es: {
          title: 'Spanien',
          ar: 'Artes',
          ma: 'Madrid',
        },
        fr: {
          title: 'Frankreich',
        },
        cz: {
          title: 'Tschechien',
        },
        sk: {
          title: 'Slowakei',
        },
        pl: {
          title: 'Polen',
        },
        be: {
          title: 'Benelux',
        },
        nl: {
          title: 'Niederlande',
        },
        uk: {
          title: 'Großbritannien',
        },
        cn: {
          title: 'China',
        },
        us: {
          title: 'USA',
        },
    }
}
}

var localeLang = 'en';
if(window.location.href.split('/')[3] == 'de') {
  localeLang = 'de';
}

// eslint-disable-next-line no-unused-vars
const i18n = new VueI18n({
  locale: localeLang, // set locale
  messages, // set locale messages
})

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')
